import axiosApi from "./ajaxToAxios"

/**
 * Fetch a label by its ID
 *
 * @param {number} id - The ID of the label to fetch
 * @returns {Promise<Response>} - A promise that resolves to the label data
 */
export const fetchLabelById = (id) =>
  axiosApi.get({
    url: `/api/v1/labels/${id}`,
  })
